module.exports = __webpack_public_path__ + "static/media/BoundBase_Application_Data_Sheet.b3a728cf.pdf";